export const LIVE_PAGE = 'LIVE_PAGE';
export const TRACK_EVENT_NAME = {
    LIVE_PAGE_WIDGET: 'LIVE_PAGE_WIDGET',
    LIVE_PAGE_WIDGET_ERROR: 'LIVE_PAGE_WIDGET_ERROR'
};
export const SELECTION_TOGGLE_FALLBACK_TIMEOUT = 30000;
export const GLOBAL_CLIENT_FETCH_TIMEOUT = 120000;

export const TRACKED_UPDATE_ENTITIES = {
    ADD: {
        EVENT: 'ADD_EVENT',
        MARKET: 'ADD_MARKET',
        SELECTION: 'ADD_SELECTION'
    },
    CHANGE: {
        EVENT: 'CHANGE_EVENT',
        MARKET: 'CHANGE_MARKET',
        SELECTION: 'CHANGE_SELECTIONS'
    },
    REMOVE: {
        EVENT: 'REMOVE_EVENT',
        MARKET: 'REMOVE_MARKET',
        SELECTION: 'REMOVE_SELECTION'
    }
};
